module.exports = __webpack_public_path__ + "static/media/intro-photowall-32.fe9d6b25.jpg";